/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Reopen_TicketInputs */

const en_admin_tickets_reopen_ticket = /** @type {(inputs: Admin_Tickets_Reopen_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reopen Ticket`)
};

const zh_admin_tickets_reopen_ticket = /** @type {(inputs: Admin_Tickets_Reopen_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新打开`)
};

/**
* | output |
* | --- |
* | "Reopen Ticket" |
*
* @param {Admin_Tickets_Reopen_TicketInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_reopen_ticket = /** @type {((inputs?: Admin_Tickets_Reopen_TicketInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Reopen_TicketInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_reopen_ticket(inputs)
	return zh_admin_tickets_reopen_ticket(inputs)
});
export { admin_tickets_reopen_ticket as "admin.tickets.reopen_ticket" }